import React from 'react';
import { SvgIcon } from '../../../common/SvgIcon';
import { simpleIconPropsTypes } from '../../propTypes';

export const IconBidReady = (props) => {
  const { width = 22, height = 22 } = props;

  const maskId = `bid-ready-${Math.random().toString(36).slice(2)}`;

  return (
    <SvgIcon width={width} height={height} viewBox="0 0 22 22">
      <defs>
        {/* White shows, black punches out */}
        <mask id={maskId} maskUnits="userSpaceOnUse">
          <rect x="0" y="0" width="22" height="22" fill="#fff" />

          {/* Cutout check (bigger + centered) */}
          <path
            d="M7.25 11.45l2.25 2.35L15.75 7.75"
            fill="none"
            stroke="#000"
            strokeWidth="3.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </mask>
      </defs>

      {/* Filled seal using the SAME outline as IconGrantOpportunities */}
      <path
        mask={`url(#${maskId})`}
        fill="currentColor"
        d="M8.364 1.507C9.189.113 10.962-.409 12.412.347c.564.294 1.024.757 1.316 1.325l.024.047.22-.118c1.385-.69 3.072-.23 3.923 1.071l.098.16c.317.555.455 1.195.395 1.832l-.005.054.235.018c1.546.167 2.726 1.48 2.74 3.046l-.004.182c-.032.639-.259 1.252-.65 1.756l-.034.042.199.151c1.198.982 1.484 2.715.666 4.035l-.108.162c-.369.521-.89.913-1.49 1.124l-.051.016.085.23c.487 1.484-.208 3.107-1.615 3.77l-.165.072c-.59.236-1.239.283-1.856.133l-.054-.013-.01.054c-.312 1.617-1.822 2.694-3.422 2.476l-.178-.03c-.624-.122-1.194-.435-1.633-.898l-.038-.04-.182.183c-1.133 1.048-2.869 1.087-4.047.09l-.15-.136c-.46-.442-.77-1.017-.892-1.645l-.01-.054-.23.05c-1.53.279-3.03-.645-3.48-2.144l-.048-.176c-.149-.622-.102-1.275.133-1.87l.02-.052-.051-.016c-1.545-.542-2.388-2.2-1.946-3.765l.054-.174c.21-.604.599-1.128 1.115-1.5l.044-.033-.148-.2c-.875-1.282-.665-3.026.489-4.06l.149-.126c.5-.394 1.109-.623 1.743-.655l.053-.003-.015-.235c-.056-1.566 1.066-2.93 2.603-3.166l.179-.022c.632-.06 1.267.08 1.818.399l.047.025z"
      />
    </SvgIcon>
  );
};

IconBidReady.propTypes = simpleIconPropsTypes;
